import React from "react";
import styled from "styled-components";
import headerImage from "../../assets/img/about.png";


export default function About() {
  return (
    <Wrapper id="about">
      <div className="whiteBg">
        <div className="container">
          {/* About Section with Image */}
          <FlexContainer>
            <ImageSection>
            <img src={headerImage} alt="VASCO Community" className="responsive-img" />


            </ImageSection>
            <TextSection>
              <h1 className="font40 extraBold">ABOUT US</h1>
              <p className="font13">
                The formation of VASCO was inspired by the growing need for
                sustainable community development and environmental conservation
                in Malawi. The organization was established in 2024 by a group
                of passionate citizens, community leaders, and professionals who
                share a common vision of promoting sustainable communities and
                protecting the environment.
              </p>
              <p className="font13">
                Malawi continues to face numerous challenges related to
                environmental degradation, poverty, and social inequality. The
                country’s natural resources are under threat from deforestation,
                pollution, and climate change, which have devastating impacts on
                local communities and their livelihoods. Furthermore, the
                increased lack of access to basic services such as healthcare,
                education, and clean water exacerbates the vulnerability of most
                communities.
              </p>
            </TextSection>
          </FlexContainer>

          {/* Mission and Vision Sections Side by Side */}
          <FlexContainer>
            <MissionSection>
              <h2 className="font30 extraBold">Mission Statement</h2>
              <p className="font13 italic">
                "The mission of VASCO is to support the development of
                sustainable communities by empowering citizens, promoting
                environmental conservation, and fostering social and economic
                justice."
              </p>
            </MissionSection>
            <VisionSection>
              <h2 className="font30 extraBold">Vision</h2>
              <p className="font13 italic">
                "A world where communities thrive in harmony with the
                environment, and where everyone has access to the resources and
                opportunities they need to reach their full potential."
              </p>
            </VisionSection>
          </FlexContainer>

          {/* Values Section */}
          <ValuesSection>
            <h2 className="font30 extraBold">Our Values</h2>
            <ul>
              <li>
                <strong>Sustainability:</strong> We prioritize the well-being of
                both people and the planet, promoting practices that minimize
                harm to the environment and ensure a livable future.
              </li>
              <li>
                <strong>Community Empowerment:</strong> We believe in the
                inherent value and capacity of communities to drive their own
                development and sustainability.
              </li>
              <li>
                <strong>Social Justice:</strong> We strive to address the root
                causes of inequality and promote fairness, equity, and human
                rights for all.
              </li>
              <li>
                <strong>Transparency and Accountability:</strong> We operate
                with integrity, transparency, and accountability, ensuring that
                our actions and decisions are open to scrutiny and feedback.
              </li>
              <li>
                <strong>Collaboration and Partnerships:</strong> We recognize
                the importance of working together with diverse stakeholders to
                achieve common goals and leverage collective impact.
              </li>
            </ul>
          </ValuesSection>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const FlexContainer = styled.div`
  display: flex;
  flex-direction: row; /* Ensure horizontal alignment */
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: nowrap; /* Prevent wrapping */
  margin-bottom: 50px;

  @media (max-width: 960px) {
    flex-direction: column; /* Stack on smaller screens */
    flex-wrap: wrap;
  }
`;

const TextSection = styled.div`
  width: 50%;
  @media (max-width: 960px) {
    width: 100%;
  }
`;
const ImageSection = styled.div`
  width: 40%; /* Adjust width to prevent squeezing */
  text-align: center; /* Align image to the left */

  @media (max-width: 960px) {
    width: 100%;
    text-align: center;
  }

  img {
    max-width: 100%;
    border-radius: 8px;
    display: block; /* Prevent inline spacing issues */
  }
`;

const MissionSection = styled.div`
  width: 48%;
  padding: 20px;
  background: #e8f5e9;
  border-radius: 8px;
  text-align: left;
  @media (max-width: 960px) {
    width: 100%;
  }
`;
const VisionSection = styled.div`
  width: 48%;
  padding: 20px;
  background: #e3f2fd;
  border-radius: 8px;
  text-align: left;
  @media (max-width: 960px) {
    width: 100%;
  }
`;
const ValuesSection = styled.div`
  padding: 20px;
  background: #fce4ec;
  border-radius: 8px;
  text-align: left;
  ul {
    margin-top: 10px;
    padding-left: 20px;
  }
  li {
    margin-bottom: 5px;
  }
`;
